module.exports = __webpack_public_path__ + "static/img/137.2e05e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/137.png
// module id = 84Tb
// module chunks = 0